class Articles extends HTMLElement {
  constructor() {
    super();

    var observer = new MutationObserver(function(mutations) {
        this.removeChildren();
        this.css();
        mutations.forEach(function(mutation) {
            if (mutation.type == "attributes") {
                if(mutation.attributeName.startsWith('article-')) {
                    mutation.target.add(JSON.parse(mutation.target.getAttribute(mutation.attributeName)));
                }
            }
        });
    }.bind(this));

    observer.observe(this, {
     attributes: true //configure it to listen to attribute changes
    });
  }

  add(article) {
      var elm = document.createElement("div");
      elm.style.backgroundImage = 'url(' + article.image + ')';
      elm.classList.add('article');
      var title = document.createElement("a");
      title.innerText = article.title;
      title.setAttribute('href', article.url);
      elm.appendChild(title);
      this.appendChild(elm);
  }

  css() {
      var css = `
      .articles {
        display: flex;
        flex-flow: wrap;
        direction: rtl;
      }

      .article {
        width: 318px;
        height: 250px;
        background-size: cover;
        background-position: center;
        margin: 4px;
        position: relative;
      }

      .article > a {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        background-color: rgba(0,0,0,.5);
        color: white;
        font-family: 'Droid-Naskh', serif;
        font-size: 16px;
        font-weight: bold;
        padding: 10px;
        direction: rtl;
      }
      `;
      var s = document.createElement('style');
      s.type = 'text/css';
      s.appendChild(document.createTextNode(css));
      this.appendChild(s);
  }

  removeChildren() {
      if(this.children.length > 0) {
        Array.from(this.children).forEach(n => {
            this.removeChild(n);
        })
      }
  }

}
customElements.define('product-articles', Articles);